import { ComposedElement } from '../element/composed-element.builder';
import {
  Page,
  PageType,
  SurveyVariables,
} from '@hyper-inferno/survey-elements-core';

export interface BaseComposedPage {
  id: number;
  name: string;
  type: PageType;
  block_id: number;
  rank: number;
  progress: number;
  elements: ComposedElement[];

  pageMeta: SurveyVariables;

  navigation: {
    showForwardButton: boolean;
    showBackwardButton: boolean;
    // isSkippable: boolean;
    // captureLocation: boolean;
  };

  pageLayout: {
    globalHeader: string;
    questionHeader: string;
    questionFooter: string;
    globalFooter: string;
  };
}

export type ComposedPage = BaseComposedPage;

export class ComposedPageBuilder {
  setProgress(progress: number) {
    this.composedPage.progress = progress;
    return this;
  }
  private composedPage: ComposedPage;
  private _page: Page;

  constructor(page: Page) {
    this._page = page;
    this.composedPage = {
      name: page.name,
      id: page.id,
      //   submissionInfo: {
      //     submissionType: SubmissionTypes.CLIENT_RESPONSE,
      //     submissionPayload: {},
      //   },
      type: page.type, // or whatever mapping is appropriate
      block_id: page.block_id, // Initialized as empty or from page
      rank: page.rank, // Or a default starting rank
      progress: 0,
      navigation: {
        showForwardButton: false,
        showBackwardButton: false,
        // isSkippable: question.isSkippable,
        // captureLocation: question.captureLocation ?? false,
      },
      pageLayout: {
        globalHeader: '',
        questionHeader: '',
        questionFooter: '',
        globalFooter: '',
      },
      elements: [],
      pageMeta: {},
    };
  }

  setQuestionVariables(variables: SurveyVariables): this {
    this.composedPage.pageMeta = variables;
    return this;
  }

  getVariables() {
    return this.composedPage.pageMeta;
  }

  getElements() {
    return (this.composedPage as any)[this.composedPage.type];
  }

  // setPageNavigation(
  //   jsn_activity_order: { questionId: string; firstVisit: string }[],
  // ) {
  //   // Extract relevant data

  //   // Parse the activity order into an array of question IDs
  //   const activityOrder = jsn_activity_order
  //     ? jsn_activity_order.map((q: any) => q.questionId)
  //     : [];

  //   // Determine the index of the current question
  //   const currentIndex = activityOrder.indexOf(this._page.id);
  //   const lastIndex = activityOrder.length - 1;

  //   // Logic to determine button visibility
  //   let showBackwardButton = currentIndex > 0; // Backward button if not the first element
  //   let showForwardButton = currentIndex < lastIndex; // Forward button if not the last element

  //   // Handle edge cases for empty or single-element arrays
  //   if (activityOrder.length <= 1) {
  //     showForwardButton = false;
  //     showBackwardButton = false;
  //   }
  //   this.composedPage.navigation = {
  //     showForwardButton,
  //     showBackwardButton,
  //   };

  //   return this;
  // }

  setPageNavigation(showForwardButton: boolean, showBackwardButton: boolean) {
    this.composedPage.navigation = {
      showForwardButton,
      showBackwardButton,
    };
    return this;
  }

  setElements(elements: ComposedElement[]) {
    this.composedPage.elements = elements;
    return this;
  }

  setTheme(themeConfig: {
    globalHeader: string;
    questionHeader: string;
    questionFooter: string;
    globalFooter: string;
  }) {
    this.composedPage.pageLayout = {
      globalHeader: themeConfig.globalHeader,
      questionHeader: themeConfig.questionHeader,
      questionFooter: themeConfig.questionFooter,
      globalFooter: themeConfig.globalFooter,
    };
    return this;
  }

  build(): ComposedPage {
    return this.composedPage;
  }
}
